import { render, staticRenderFns } from "./OrderListCompleted.vue?vue&type=template&id=19272343"
import script from "./OrderListCompleted.vue?vue&type=script&lang=ts"
export * from "./OrderListCompleted.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports